export const LIST_STAFFS = 'LIST_STAFFS';
export const CREATE_STAFF = 'CREATE_STAFF';
export const UPDATE_STAFF = 'UPDATE_STAFF';
export const REMOVE_STAFF = 'REMOVE_STAFF';